module.exports = __webpack_public_path__ + "img/location-tip.0fcc091d.png";